import { Platform, Image } from 'react-native';
import { Asset } from 'expo-asset';
import assetPaths from './assetPaths';

// let assets = assetPaths;
 
console.log('assetPaths', assetPaths);

// 🔹 ฟังก์ชันช่วยโหลด assets ตามแพลตฟอร์ม
// const getAsset = (asset: number): string | number => {
const getAsset = (asset: number) => {
  if (!asset) {
    console.warn('[getAsset] asset is null or undefined!');
    return 0; // Return empty string or appropriate fallback
  }

  // หากพบว่า asset เป็นฟังก์ชันหรือ key ที่ไม่ใช่ asset ให้ข้าม
  if (typeof asset === 'function') {
    console.warn(`[getAsset] asset is a function: ${asset}`);
    return 0; // หรือสามารถใช้ fallback อื่น ๆ ได้
  }

  if (!asset) {
    console.warn('[getAsset] asset is null or undefined!');
    return 0; // Return empty string or appropriate fallback
  }

  // // return Platform.OS === 'web' ? asset : Asset.fromModule(asset).uri;
  // if (!asset) {
  //   console.warn('[getAsset] asset is null or undefined!');
  //   // return '';
  //   return 0;
  // }
  // return Platform.OS === 'web' ? asset : Asset.fromModule(asset).uri;
  // return Platform.OS === 'web' ? asset : Asset.fromModule(asset);
  // return Asset.fromModule(asset);
  return asset;
  // return Image.resolveAssetSource(asset).uri;
};

const sanitizeAssets = (obj: any): any => {
  const cleanObj: any = {};
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      cleanObj[key] = sanitizeAssets(obj[key]);
    } else if (obj[key]) {
      cleanObj[key] = obj[key];
    }
  }
  return cleanObj;
};

// // 🔹 ใช้ TypeScript Generics เพื่อรักษาโครงสร้างของ assetPaths
// // eslint-disable-next-line arrow-body-style
// const createAssetProxy = <T extends Record<string, any>>(obj: T): T => {
//   // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
//   return new Proxy(obj, {
//     get(target, prop) {
//       const value = target[prop as keyof T];
//       return typeof value === 'object' && value !== null
//         ? createAssetProxy(value) // 🔄 ถ้าเป็น object ให้สร้าง Proxy ซ้อนอีกชั้น
//         : getAsset(value)  // 🖼 ถ้าเป็น asset ให้แปลงเป็น URI
//     }
//   }) as T; // ⬅ ใช้ as T เพื่อรักษาโครงสร้างข้อมูล
// };

// eslint-disable-next-line arrow-body-style
const createAssetProxy = <T extends Record<string, any>>(obj: T): T => {
  // console.log(`[createAssetProxy] obj:`, obj);
  return new Proxy(obj, {
    get(target, prop) {
      if (typeof prop !== 'string' || prop.startsWith('$$')) {
        return undefined; // ❌ ข้าม key แปลก ๆ ของ React
      }
    
      const value = target[prop as keyof T];
      if (typeof value === 'object' && value !== null) {
        return createAssetProxy(value);
      }
    
      if (!value) {
        console.warn(`[createAssetProxy] Asset key "${String(prop)}" is null or undefined!`);
      }
    
      return getAsset(value);
    }
  }) as T;
};

// 🔹 ใช้ Proxy กับ assetPaths เพื่อรองรับ assets ที่ซ้อนกัน
// const assets = createAssetProxy(sanitizeAssets(assetPaths));
const assets = createAssetProxy(assetPaths);
// const assets = assetPaths;

// // 🔹 ฟังก์ชันโหลด assets เฉพาะบน Native
// export const loadAssets = async (): Promise<void> => {
//   const loadAssetsRecursively = (assets: any) => {
//     Object.values(assets).forEach((asset) => {
//       if (typeof asset === 'object') {
//         loadAssetsRecursively(asset);  // ทำการเรียกตัวเองถ้าเจอ object
//       } else {
//         Asset.loadAsync([asset]);  // โหลด asset ถ้าเป็นค่าอื่นๆ
//       }
//     });
//   };

//   if (Platform.OS !== 'web') {
//     loadAssetsRecursively(assetPaths);  // เรียกฟังก์ชัน recursive กับ assetPaths
//   }
// };

// 🔹 ฟังก์ชันโหลด assets เฉพาะบน Native
export const loadAssets = async (): Promise<void> => {
  // assets = createAssetProxy(assetPaths);
  // console.log('[loadAssets] assets:', assets);

  // สร้าง array สำหรับเก็บ asset ทั้งหมด
  const assetsToLoad: any[] = [];
  const assetsToLoadMap: Record<string, any> = {};

  const loadAssetsRecursively = (assets: any) => {
    Object.keys(assets).forEach((assetKey) => {
      const asset = assets[assetKey];
      if (typeof asset === 'object') {
        // ถ้าเป็น object, ให้ทำการเรียก recursive
        loadAssetsRecursively(asset);
      } 

      // ถ้าเป็น asset ที่ต้องการโหลด, ให้เพิ่มลงใน array
      if (typeof asset === 'number' && asset) {
        assetsToLoad.push(asset);
        // assetsToLoadMap[assetKey] = asset; // เก็บ asset ที่โหลดแล้วใน map
        assetsToLoadMap[asset] = assetKey; // เก็บ asset ที่โหลดแล้วใน map
      }
    });
  };
  
  if (Platform.OS !== 'web') {
    // เรียกฟังก์ชัน recursive กับ assetPaths เพื่อรวบรวม assets ทั้งหมด
    loadAssetsRecursively(assetPaths.images);
    console.log('[loadAssets] Assets to load:', assetsToLoad);
    console.log('[loadAssets] Assets to load map:', assetsToLoadMap);
    
    // โหลด assets ทั้งหมดทีเดียว
    if (assetsToLoad.length > 0) {
      try {
        await Asset.loadAsync(assetsToLoad);
        console.log('[loadAssets] Assets Loaded:', assetsToLoad);
      } catch (error) {
        console.error('[loadAssets] Error loading assets:', error);
      }
    }
  }
};

export default assets;
